import { render } from "./Drivers.vue?vue&type=template&id=0fb8151a"
import script from "./Drivers.vue?vue&type=script&lang=js"
export * from "./Drivers.vue?vue&type=script&lang=js"

import "./Drivers.vue?vue&type=style&index=0&id=0fb8151a&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__